export const MenuTab = {
  ALL: "All",
  PUBLISHED: "Published",
  PENDING_PUBLISH: "Pending To Publish",
  PENDING_DELETION: "Pending To Deletion",
  DELETED: "Deleted",
};

export const FilterMenu = {
  all: "ALL",
  published: "PUBLISHED",
  pen_publish: "PENDING_PUBLISH",
  pen_delete: "PENDING_DELETION",
  delete: "DELETED",
};
